import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { ProgressSpinner } from "primereact/progressspinner";

import { getFullLessonDetails } from "sj-ui-toolkit/src/client";
import { LearnAppRoutes } from "sj-ui-toolkit/src/constants/routes";

const LegacyLessonRedirect = () => {
  const { beltId, lessonId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getFullLessonDetails({ lessonId, levelId: beltId })
      .then(response => {
        const lessonKey = response.data?.lesson?.lessonKey;
        if (lessonKey) {
          navigate(LearnAppRoutes.routes.lesson.route.replace(":lessonKey", lessonKey), {
            replace: true,
          });
        } else {
          navigate(LearnAppRoutes.route, { replace: true });
        }
      })
      .catch(() => {
        navigate(LearnAppRoutes.route, { replace: true });
      });
  }, [beltId, lessonId, navigate]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex items-center justify-center w-full h-full"
    >
      <div className="flex flex-col items-center">
        <ProgressSpinner animationDuration="1s" aria-hidden="true" />
        <span className="mt-4 text-lg">Redirecting to lesson…</span>
      </div>
    </div>
  );
};

export default LegacyLessonRedirect;
